import React, { Component } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import UpdatePaymentOptionForm from './UpdatePaymentOptionForm';
import Dialog from '../../../../common/components/Dialog';
import { withTranslation } from 'react-i18next';

class UpdatePaymentOptionDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			stripeInstance: null
		};
	}

	componentDidMount() {
		const { payment: { paymentMethod: { configuration } } } = this.props;
		const stripe = loadStripe(configuration.publishableApiKey, {
			stripeAccount: configuration.connectedAccountId   // perform calls on behalf of a connected Stripe account
		});
		this.setState({ stripeInstance: stripe });
	}

	renderBody() {
		const { payment, currency, onConfirm, error } = this.props;
		const configuration = payment.paymentMethod.configuration;

		const options = {
			mode: 'setup',
			currency: currency.toLowerCase(),
			payment_method_configuration: configuration.paymentMethodConfigurationId
		};

		return <Elements stripe={this.state.stripeInstance} options={options}>
				<ElementsConsumer>
					{({ stripe, elements }) => (
					<UpdatePaymentOptionForm stripe={stripe} elements={elements} payment={payment} onSubmit={onConfirm} error={error} />
					)}
				</ElementsConsumer>
			</Elements>;
	}

	render() {
		const { onCancel, onConfirm, payment, currency, error, t, ...rest } = this.props;
		return <Dialog onHide={onCancel} header={t('FO_Payment_PaymentOption_Update')} body={this.renderBody()} footer={<div />} {...rest} />
	}
}

export default withTranslation()(UpdatePaymentOptionDialog);